//交易品种明细
const symbol = {
  USDCNH: '美元离岸人民币',
  GBPUSD: '英镑美元',
  USDCHF: '美元瑞郎',
  EURUSD: '欧元美元',
  AUDUSD: '澳元美元',
  USDJPY: '美元日元',
  NZDUSD: '纽元美元',
  USDCAD: '美元加元',
  AUDNZD: '澳元纽元',
  EURJPY: '欧元日元',
  NZDJPY: '纽元日元',
  AUDJPY: '澳元日元',
  CADJPY: '加元日元',
  EURAUD: '欧元澳元',
  EURCHF: '欧元瑞郎',
  EURGBP: '欧元英镑',
  GBPCHF: '英镑瑞郎',
  GBPAUD: '英镑澳元',
  GBPJPY: '英镑日元',
  USDHKD: '美元港币',
  XAUUSD: '伦敦金',
  XAGUSD: '伦敦银',
  USOIL: '美国原油',
  UKOIL: '英国原油',
  US30: '道琼斯指数',
  US500: '标准普尔指数',
  GER30: '德国指数',
  HK50: '恒生指数',
  NAS100: '纳斯达克指数',
  JPN225: '日经指数',
  CHINA300: '中华300',
  CHA50: '中华50',
  BIDUL: '百度',
  BABA: '阿里巴巴',
  AAPL: '苹果',
  KO: '可口可乐',
  FB: '脸书',
  GS: '高盛',
  DIS: '迪士尼',
  MSFT: '微软',
  BTCusdt10x: '比特币',
  BCHusdt10x: '比特币现金',
  ETHusdt10x: '以太坊',
  LTCusdt10x: '莱特币',
  DOTusdt10x: '波卡币',
  FIL100x: '菲乐币100倍',
  BTC100x: '比特币100倍',
  DOT100x: '波卡币100倍',
  BCH100x: '比特币现金100倍',
  ETH100x: '以太坊100倍',
  LTC100x: '莱特币100倍',
  ADA100x: '艾达币100倍',
  DOGE100x: '狗狗币100倍',
  USDCNH: '美元离岸人民币',
  GBPUSD: '英镑美元',
  USDCHF: '美元瑞郎',
  EURUSD: '欧元美元',
  AUDUSD: '澳元美元',
  USDJPY: '美元日元',
  NZDUSD: '纽元美元',
  USDCAD: '美元加元',
  AUDNZD: '澳元纽元',
  EURJPY: '欧元日元',
  NZDJPY: '纽元日元',
  AUDJPY: '澳元日元',
  CADJPY: '加元日元',
  EURAUD: '欧元澳元',
  EURCHF: '欧元瑞郎',
  EURGBP: '欧元英镑',
  GBPCHF: '英镑瑞郎',
  GBPAUD: '英镑澳元',
  GBPJPY: '英镑日元',
  USDHKD: '美元港币',
  XAUUSD: '伦敦金',
  XAGUSD: '伦敦银',
  USOIL: '美国原油',
  UKOIL: '英国原油',
  US30: '道琼斯指数',
  US500: '标准普尔指数',
  GER30: '德国指数',
  HK50: '恒生指数',
  NAS100: '纳斯达克指数',
  JPN225: '日经指数',
  CHINA300: '中华300',
  CHA50: '中华50',
  BTCUSDT: '比特币',
  ETHUSDT: '以太坊',
  LTCUSDT: '莱特币',
  DOTUSDT: '波卡币',
  BCHUSDT: '比特币现金',
  FILUSDT: '文件币',
  ADAUSDT: '艾达币',
  DOGEUSDT: '狗狗币',
  AXSUSDT: 'AXS币',
  SOLUSDT: 'Solana币',
  SANDUSDT: '沙盒币',
  ATOMUSDT: '阿童木币',
  AAVEUSDT: 'AAVE币',
  UNIUSDT: 'UNI币',
  PA: '钯金',
  PL: '铂金',
  RMBGOLD: '人民币黄金',
  人民币黄金: '人民币黄金',
}
export default symbol



// WEBPACK FOOTER //
// ./src/utils/symbol.js